module.exports = __webpack_public_path__ + "img/lesson.a50d8c54.svg";